export default "__VITE_ASSET__1yChdiZV__"